import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const AutoAssignmentLazyLoadedStates= new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    rules: LazyLoadedStates,
    logs: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.administration.auto-assignment',
        url: '/auto-assignment',
        abstract: true,
    }, 
    rules: {
        name: 'authenticated.administration.auto-assignment.rules',
        url: '/rules'
    },
    logs: {
        name: 'authenticated.administration.auto-assignment.logs',
        url: '/logs/:page?limit&searchBy&orderBy&ascending&status&followupActionsOnly&startTime&endTime',
        params: {
            page: {
                raw: true,
                type: 'int',
                value: 1
            },
            limit: {
                raw: true,
                type: 'int',
                value: 20
            },
            searchBy: {
                raw: true,
                type: 'string',
                value: '',
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'false'
            },
            status: {
                raw: true,
                type: 'int'
            },
            // filters
            followupActionsOnly: {
                raw: true,
                type: 'bool',
                value: true
            },
            startTime: {
                raw: true,
                type: 'int',
                value: () => new Date().getTime() - (24 * 60 * 60 * 1000) // Default to 24 hours ago
            },
            endTime: {
                raw: true,
                type: 'int',
                value: () => new Date().getTime() // Default to now
            }
        }
    }
},
() => import('src/app/auto-assignment/pages/auto-assignment.module').then((result: {AutoAssignmentModule: any}) => result.AutoAssignmentModule)
);
